var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M36.75 0H5.25C2.35462 0 0 2.35462 0 5.25V36.75C0 39.6454 2.35462 42 5.25 42H21V27.5625H15.75V21H21V15.75C21 11.4004 24.5254 7.875 28.875 7.875H34.125V14.4375H31.5C30.051 14.4375 28.875 14.301 28.875 15.75V21H35.4375L32.8125 27.5625H28.875V42H36.75C39.6454 42 42 39.6454 42 36.75V5.25C42 2.35462 39.6454 0 36.75 0Z","fill":"white"}));
}

Facebook.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
